// extracted by mini-css-extract-plugin
module.exports = {"footer":"k_2uuI9","inner":"k_2XrLh","wrap":"k_3wmlH","socMedia":"k_1GrhF","menuList":"k_2eVX9","menu":"k_3gIgJ","callMessage":"k_2GcaP","hideItem":"k_2oHz6","arrowUp":"k_2U6dt"};